import { left, paddingLeft, paddingRight } from '@/utils/directions';
import { colorAccent, colorIcon, colorText, colorWhite } from '@/utils/palette';
import React from 'react';
import styled from 'styled-components';

const RadioButtonGroupField = ({
  name,
  label,
  value,
  onChange,
  defaultValue,
  styleType,
  disabled = false,
  radioButtons,
  error,
  alignVertically = false,
  helperText,
  hideLabel = false,
}) => {
  const handleChange = (e, radioValue) => {
    onChange(radioValue);
  };

  return (
    <div>
      {label && <Label error={error}>{label}</Label>}
      {radioButtons?.map((item, index) => (
        <RadioButtonWrap
          key={index}
          disabled={disabled || item?.disabled}
          styleType={styleType}
          alignVertically={alignVertically}
          hideLabel={hideLabel}
        >
          <RadioButtonInput
            name={name}
            type='radio'
            onChange={(e) => handleChange(e, item?.radioValue)}
            checked={value === item?.radioValue}
            disabled={disabled || item?.disabled}
          />
          <RadioButtonCustom disabled={disabled || item?.disabled} />
          {!hideLabel && (
            <RadioButtonLabel
              disabled={disabled || item?.disabled}
              hideLabel={hideLabel}
            >
              {item?.label}
            </RadioButtonLabel>
          )}
        </RadioButtonWrap>
      ))}
      {helperText && <HelperText>{helperText}</HelperText>}
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </div>
  );
};

export default RadioButtonGroupField;

// region STYLES
const Label = styled.div`
  font-size: 12px;
  margin-top: 5px;
  margin-bottom: 5px;
  color: ${(props) => (props.error ? 'red' : colorText)};
`;

const ErrorMessage = styled.div`
  color: red;
  margin-top: 5px;
  margin-bottom: 20px;
  font-size: 12px;
`;

const HelperText = styled.div`
  font-size: 12px;
  margin-top: 5px;
  color: ${colorText};
`;

const RadioButtonCustom = styled.span`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  position: relative;
  transition: all 0.3s;
  border: 1px solid ${colorIcon};
  display: inline-block;
  vertical-align: middle;
  background: ${(props) => (props.disabled ? '#f0f0f0' : 'transparent')};
  border-color: ${(props) => (props.disabled ? '#bdbdbd' : colorIcon)};
`;

const RadioButtonInput = styled.input`
  display: none;

  &:checked + ${RadioButtonCustom} {
    border-color: ${colorAccent};

    &::before {
      content: '';
      display: block;
      position: absolute;
      width: 6px;
      height: 6px;
      top: calc(50% - 3px);
      background: ${colorAccent};
      border-radius: 50%;
      ${left}: calc(50% - 3px);
    }
  }
`;

const RadioButtonLabel = styled.span`
  line-height: 18px;
  transition: all 0.3s;
  margin-top: 5px;
  display: inline-block;
  vertical-align: middle;
  // ${paddingLeft}: 9px;
  ${({ hideLabel }) => (hideLabel ? '' : 'padding-left: 9px;')}
  color: ${(props) => (props.disabled ? '#bdbdbd' : colorText)};
`;

const RadioButtonWrap = styled.label`
  display: ${({ alignVertically }) => (alignVertically ? 'block' : 'inline-block')};
  margin: ${({ alignVertically }) => (alignVertically ? '16px 0' : '0')};
  cursor: pointer;
  flex-direction: inherit;
  padding: 0;
  // ${paddingRight}: 20px;
  ${({ hideLabel }) => (hideLabel ? '' : 'padding-right: 20px;')}

  ${(props) =>
    props.disabled &&
    `
    pointer-events: none;
    cursor: default;
    opacity: 0.4;
  `}

  &:hover {
    ${RadioButtonCustom} {
      border-color: ${colorAccent};
    }

    ${RadioButtonLabel} {
      color: ${colorAccent};
    }
  }

  ${(props) =>
    props.styleType === 'colored' &&
    `
    flex-direction: inherit;
    padding: 0;

    ${RadioButtonCustom} {
      border: 2px solid ${colorAccent};
    }
  `}

  ${(props) =>
    props.styleType === 'colored-click' &&
    `
    flex-direction: inherit;
    padding: 0;

    ${RadioButtonInput}:checked + ${RadioButtonCustom} {
      background: ${colorAccent};

      &::before {
        background: ${colorWhite};
      }
    }

    ${
      props.disabled &&
      `

      ${RadioButtonInput}:checked + ${RadioButtonCustom} {
        background: transparent;

        &::before {
          background: ${colorAccent};
        }
      }
    `
    }
  `}

  @media screen and (max-width: 370px) {
    display: flex;
    align-items: center;
  }

  @media screen and (max-width: 575px) {
    display: inline-block;
  }

  @media screen and (max-width: 515px) {
    display: flex;
    align-items: center;
  }

  @media screen and (max-width: 500px) {
    display: inline-block;
  }

  @media screen and (max-width: 356px) {
    display: flex;
    align-items: center;
  }
`;

// endregion
